import { memo } from 'react'

import Image from 'next/image'

import SingleStar from '@/assets/images/storefronts/clashofclans/single_small_star.png'
import StarCoin from '@/assets/images/storefronts/clashofclans/star_coin.png'

import { StoreTypography } from '../typography/StoreTypography'

import styles from './valueIndicator.module.scss'

//TODO: Intl for "value"

export const ClashValueIndicator = memo(({ value }: { value: number }) => {
  return (
    <div className={styles.clashValueIndicator}>
      <div className={styles.icons}>
        <Image src={StarCoin} alt="" width={18} className={styles.starCoin} />
        <Image src={SingleStar} alt="" width={10} />
      </div>
      <div className={styles.textWrapper}>
        <StoreTypography tag="div" textSize="lg" style="outlined" lineHeight="tight" className={styles.valueNumber}>
          {value}
          <StoreTypography tag="span" textSize="sm" style="outlined" lineHeight="tight">
            x
          </StoreTypography>
        </StoreTypography>
        <StoreTypography tag="div" textSize="sm" style="outlined" lineHeight="tight" className={styles.valueText}>
          value
        </StoreTypography>
      </div>
    </div>
  )
})

ClashValueIndicator.displayName = 'ClashValueIndicator'
